define([], () => {
    'use strict';
    const computedStyle = getComputedStyle(document.body);
    const minDistance = () => parseInt(computedStyle.getPropertyValue('--lfi-scroll-direction-min-distance-px') || 0, 10);
    const delay = () => parseInt(computedStyle.getPropertyValue('--lfi-scroll-direction-delay-ms') || 0, 10);


    return () => {
        let changeDirectionScrollPosition = scrollY;
        let previousTickScrollPosition = changeDirectionScrollPosition;
        let isScrollingUp = scrollY === 0;
        let queuedAnimationFrame = false;
        let timeout = false;
        const classList = document.body.classList;
        classList.add(isScrollingUp ? 'scrolling-up' : 'scrolling-down');

        function defer (cb) {
            timeout = setTimeout(() => {
                clearTimeout(timeout);
                cb();
            }, delay());
        }

        function updateScrollDirection () {
            if (changeDirectionScrollPosition - minDistance() > scrollY && classList.contains('scrolling-down')) {
                defer(() => {
                    classList.add('scrolling-up');
                    classList.remove('scrolling-down');
                });
            }
            if (changeDirectionScrollPosition + minDistance() < scrollY && classList.contains('scrolling-up')) {
                defer(() => {
                    classList.add('scrolling-down');
                    classList.remove('scrolling-up');
                });
            }

            if ((scrollY > previousTickScrollPosition && isScrollingUp) ||
                (scrollY < previousTickScrollPosition && !isScrollingUp)) {
                isScrollingUp = scrollY < previousTickScrollPosition;
                changeDirectionScrollPosition = scrollY;
            }

            previousTickScrollPosition = scrollY;
        }

        addEventListener('scroll', () => {
            if (queuedAnimationFrame) {
                return;
            }

            requestAnimationFrame(() => {
                queuedAnimationFrame = false;

                updateScrollDirection();
            });

            queuedAnimationFrame = true;
        });
    };
});
